import {
  Input, Directive
} from '@angular/core';
import {Base} from '../../../common/model/base.model';
import {AuthService} from '../../../auth/auth.service';
import {ConfigService} from '../../../core/config.service';
import {Helpers} from '../../../common/helpers/helpers';
import {FormCommonTag} from './form-common-tag';

// declare var jquery: any;   // not required
declare var $: any;   // not required
@Directive()
export abstract class Select2AngularComponent extends FormCommonTag {

  public static ADD_ANOTHER = 'Aggiungi altri elementi';

  public static SEARCHING_MARKUP = 'Sto cercando';

  public static ERROR_MARKUP = 'I risultati non';

  @Input() allowClear = false;

  @Input() path: string = null;     // relative path. Se popolato attiva la funzionalità ajax di select2.

  @Input() pathParams: {} = {};     // ajax params oltre il term di ricerca ex. { 'userId': '1'}

  @Input() template: () => string;

  @Input() baseBuilder;

  @Input() multiple;

  @Input() disable;

  @Input() showAsList: false;

  id = 'select' + this.randomId();

  asyncInitialized = false;

  constructor(protected authService: AuthService,
              protected configService: ConfigService) {
    super();
  }

  protected abstract select(e);

  protected abstract unselect(e);

  protected abstract getSelected();

  /**
   * Inizializza la select2.
   *
   * TODO: se this.params cambia la select2 dovrà essere reinizializzata (in genere è fissato).
   */
  protected initializeSelect2() {

   const obj = {
      theme: 'bootstrap',
      width: null,
      allowClear: this.allowClear,
      placeholder: this.placeholder,
      containerCssClass: ':all:',
      language: this.language(),
      disabled: this.disable
    };

    obj['escapeMarkup'] = function(markup) {
      if (!markup) {
        return markup;
      }
      if (markup.startsWith(Select2AngularComponent.ERROR_MARKUP)) {
        return '<div><i class=\"fa fa-times text-danger\"></i>' +
          ' Impossibile recuperare i risultati della ricerca.<br>' +
          '<em>Riprovare o effettuare una segnalazione.</em></div>';
      }
      if (markup.startsWith(Select2AngularComponent.SEARCHING_MARKUP)) {
        return '<i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Sto cercando ...';
      }
      return markup;
    };

    if (this.template) {
      obj['templateResult'] = function(data) {
        if (data.loading) {
          return data.text;
        }
        if (data.entity) {
          return this.template(this.baseBuilder(data.entity));
        }
        if (data instanceof Base) {
          return this.template(data); // TODO: verificarlo nel caso di not async.
        }
        const option = this.items.filter((item) => item.getId() === +data.id)[0];
        if (option) {
          return this.template(option);
        }
        return data;
      }.bind(this);
      obj['templateSelection'] = function(data) {
        if (!this.selected) {
          return this.placeholder;
        }
        if (this.selected.entity) {
          return this.template(this.baseBuilder(this.selected.entity), true, Select2AngularComponent.ADD_ANOTHER, this.showAsList);
        }
        return this.template(this.selected, true, Select2AngularComponent.ADD_ANOTHER, this.showAsList);
      }.bind(this);
    }

    const selector = this.cssSelector();

    if (this.path) {

      this.configService.getApiBase().subscribe( apiBase => {
          obj['ajax'] = {
            'url': apiBase + this.path,
            'delay': '600',
            'dataType': 'json',
            'transport': this.transport.bind(this)
          };
          obj['minimumInputLength'] = 2;

          // l'inizializzazione async deve avvenire prima di costruire la select2, altrimenti si crea la option
          // visualizzata duplicata. Indagare se serve.
          this.asyncInitialValue();
          this.asyncInitialized = true;

          $(selector).select2(obj);
          $(selector).on('select2:select', this.select.bind(this));
          $(selector).on('select2:unselecting', this.unselect.bind(this));
      });

    } else {
      $(selector).select2(obj);
      $(selector).on('select2:select', this.select.bind(this));
      $(selector).on('select2:unselecting', this.unselect.bind(this));
    }

    this.fixDropDown();
  }

  /**
   * La chiamata ajax deve essere fatta con il token rinnovato ...
   * @param params
   * @param success
   * @param failure
   * @returns {Subscription}
   */
  public transport(params, success, failure) {
    params.url = params.url + '?' + Helpers.objToQueryParam(this.pathParams);
    return this.authService.getRefreshedToken().subscribe( (tok) => {
      params['headers'] = {'Authorization': 'Bearer' + tok.access_token};
      const $request = $.ajax(params);
      $request.then(success);
      $request.fail(failure);
      return $request;
    });
  }

  /**
   * Create the selected option and append to Select2 (single async version).
   */
  private asyncInitialValue() {
    if (!this.asyncInitialized && this.path && !this.multiple && this.getSelected()) {
      const selector = this.cssSelector();
      const selected = this.getSelected();
      const option = new Option(this.getSelected().getLabel(), this.getSelected().getId(), true, true);
      $(selector).append(option).trigger('change');
      // manually trigger the `select2:select` event
      $(selector).trigger({
        type: 'select2:select',
        params: {
          data: this.getSelected()
        }
      });
    }
  }

  // -----------------------------
  // Utils
  // -----------------------------

  private fixDropDown() {
    // FIX https://github.com/select2/select2/issues/4614
    const selector = this.cssSelector();
    const select2Instance = $(selector).data('select2');
    select2Instance.on('results:message', function(params){
      this.dropdown._resizeDropdown();
      this.dropdown._positionDropdown();
    });
  }


  randomId() {
    return Math.floor(Math.random() * (1000 - 1 + 1)) + 1;
  }

  cssSelector() {
    return '.' + this.id;
  }

  protected language() {
    // FIXME: integrare la traduzione select2.
    // * Questa traduzione è copiata dalla dist di select2.
    // Italian
    return {
      errorLoading: function () {
        return 'I risultati non possono essere caricati.';
      },
      inputTooLong: function (args) {
        const overChars = args.input.length - args.maximum;

        let message = 'Per favore cancella ' + overChars + ' caratter';

        if (overChars !== 1) {
          message += 'i';
        } else {
          message += 'e';
        }

        return message;
      },
      inputTooShort: function (args) {
        const remainingChars = args.minimum - args.input.length;

        const message = 'Per favore inserisci ' + remainingChars + ' o più caratteri';

        return message;
      },
      loadingMore: function () {
        return 'Caricando più risultati…';
      },
      maximumSelected: function (args) {
        let message = 'Puoi selezionare solo ' + args.maximum + ' element';

        if (args.maximum !== 1) {
          message += 'i';
        } else {
          message += 'o';
        }

        return message;
      },
      noResults: function () {
        return 'Nessun risultato trovato';
      },
      searching: function () {
        return 'Sto cercando…';
      }
    };
  }
}

